import { NestedDossierProcessesOpenSearch } from '@europrocurement/l2d-domain';
import { Box, CircularProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { FieldValues, useForm } from 'react-hook-form';
import { OptionsType } from '@europrocurement/flexy-components';
import { DossierValidatorStatus } from '@europrocurement/l2d-modules';

type UpdateValideurFormProps = {
    processing: boolean;
    onStatusChanged: (newStatus: DossierValidatorStatus) => void;
    process: NestedDossierProcessesOpenSearch;
    statuses: Array<DossierValidatorStatus>;
};

const UpdateValidatorForm: React.FunctionComponent<UpdateValideurFormProps> = function ({
    processing,
    onStatusChanged,
    process,
    statuses,
}) {
    const [typeStatus, setTypeStatus] = useState<OptionsType>([]);
    const [isLoading, setIsLoading] = useState(false);
    const currentStatus = { value: process?.statusCode || '', label: process?.statusLabel || '' };

    useEffect(() => {
        setTypeStatus(
            statuses
                .sort((a, b) => (a.sortOrder as number) - (b.sortOrder as number))
                .map((status) => ({
                    value: status.code,
                    label: status.label as unknown as string,
                })),
        );
    }, [statuses]);

    const formContext = useForm<FieldValues>({
        mode: 'onChange',
        defaultValues: {
            statusCode: currentStatus,
        },
    });

    const selectedStatus = formContext.watch('statusCode');

    const handleFormSubmit = (value: string) => {
        if (value) {
            const realStatus = statuses.find((s) => s.code === value);

            if (realStatus) {
                setIsLoading(true);
                onStatusChanged(realStatus);
            }
        }
    };

    // Catch select onChange
    useEffect(() => {
        if (
            !isLoading &&
            !processing &&
            selectedStatus &&
            selectedStatus.value !== currentStatus.value
        ) {
            handleFormSubmit(selectedStatus.value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedStatus, currentStatus]);

    const formProps = {
        formContext,
        onSubmit: () => {},
        submitButton: {
            displayed: false,
        },
    };

    const formStructure: FormStructure[] = [
        {
            type: 'select',
            name: 'statusCode',
            inputlabel: 'Statut',
            options: typeStatus,
            getOptionLabel: ({ label }: { label: string }) => label,
            getOptionValue: ({ value }: { value: string }) => value,
            xs: 12,
        },
    ];

    return (
        <Box sx={{ minWidth: '500px' }}>
            <Typography variant="l2dh6">Modifier le statut</Typography>
            <Box
                sx={{
                    padding: '26px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    rowGap: '10px',
                }}
            >
                {isLoading ? (
                    <CircularProgress size={20} />
                ) : (
                    <FlexyForm
                        formStructure={formStructure}
                        {...formProps}
                    />
                )}
            </Box>
        </Box>
    );
};

export default UpdateValidatorForm;
